export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7142.ed1abfda.jpg";